import { render, staticRenderFns } from "./prodItem.vue?vue&type=template&id=06f6ceeb&scoped=true"
import script from "./prodItem.vue?vue&type=script&lang=js"
export * from "./prodItem.vue?vue&type=script&lang=js"
import style0 from "./prodItem.vue?vue&type=style&index=0&id=06f6ceeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6ceeb",
  null
  
)

export default component.exports